// extracted by mini-css-extract-plugin
module.exports = {"tx_green":"Footer_tx_green__l7o8x","contentFooter":"Footer_contentFooter__3AH8F"};